(() => {
  const instances = new Map();
  const sliderUtils = window.AWSliderCoreUtils;

  class AWCollectionRelatedArticles {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector("[data-aw-collection-related-articles-viewport]");
      this.scrollbar = root.querySelector("[data-aw-collection-related-articles-scrollbar]");
      this.thumb = root.querySelector("[data-aw-collection-related-articles-scrollbar-thumb]");
      this.rafId = null;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onImageLoad = this.onImageLoad.bind(this);

      this.bindEvents();
      this.bindImageLoad();
      this.update();
    }

    bindEvents() {
      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      window.addEventListener("resize", this.onResize);
    }

    bindImageLoad() {
      sliderUtils.bindImageLoad(this.root, this.onImageLoad);
    }

    destroy() {
      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      window.removeEventListener("resize", this.onResize);

      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    onScroll() {
      if (this.rafId) return;

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    onResize() {
      window.requestAnimationFrame(() => this.update());
    }

    onImageLoad() {
      this.update();
    }

    update() {
      this.updateScrollbar();
    }

    updateScrollbar() {
      if (!this.viewport || !this.scrollbar || !this.thumb) return;

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const current = this.viewport.scrollLeft;
      const hasOverflow = maxScroll > 1;

      sliderUtils.updateScrollbar({
        viewport: this.viewport,
        scrollbar: this.scrollbar,
        thumb: this.thumb,
        enabled: hasOverflow
      });
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-collection-related-articles]").forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new AWCollectionRelatedArticles(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-collection-related-articles]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => destroy(event.target));
})();
